import React, { ReactNode } from 'react';
import { get } from 'lodash';
import {
  FormControl,
  FormControlProps,
  FormHelperText,
  InputLabel,
  Select,
  SelectProps,
} from '@material-ui/core';
import { Controller, UseFormMethods } from 'react-hook-form';

interface RHFSelectProps extends FormControlProps {
  name: string;
  label: string;
  control: UseFormMethods['control'];
  errors: UseFormMethods['errors'];
  defaultValue?: string | number;
  children: ReactNode | ReactNode[];
  SelectProps?: SelectProps;
  helperText?: string;
}

export const RHFSelect = ({
  name,
  label,
  control,
  defaultValue,
  children,
  errors,
  SelectProps,
  helperText,
  ...rest
}: RHFSelectProps) => {
  const labelId = `${name}-label`;
  const error = get(errors, name);

  return (
    <FormControl {...rest} error={!!error} variant="outlined">
      <InputLabel error={!!error} id={labelId}>
        {label}
      </InputLabel>

      <Controller
        render={(props) => (
          <Select
            labelId={labelId}
            label={label}
            {...props}
            onChange={(event, child) => {
              props.onChange(event);
              if (SelectProps?.onChange) {
                SelectProps.onChange(event, child);
              }
            }}
          >
            {children}
          </Select>
        )}
        name={name}
        defaultValue={defaultValue}
        control={control}
      />
      {error && <FormHelperText error>{error.message}</FormHelperText>}
      {helperText && !error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
